// @flow
import * as React from 'react'
import SectionStandardHeading from './SectionStandardHeading'

import './Section.scss'

type Props = {
  actions?: React.Node,
  title?: React.Node,
  children: React.Node,
}

export default class Section extends React.Component<Props> {
  render = () => {
    return (
      <div className="Section">
        {this.renderHeadingMaybe()}
        {this.props.children}
      </div>
    )
  }

  renderHeadingMaybe = () => {
    if (!this.props.title && !this.props.actions) return null
    return <SectionStandardHeading actions={this.props.actions} title={this.props.title} />
  }
}
